module.exports = __webpack_public_path__ + "media/images/athletes/139-c97a5f9bf1d15cd5252e7d9e2df8d4ca.png";